import request from '@/utils/request'
// 退货订单列表
export function refundOrderList(params) {
  return request({
    url: '/afterSales/cancelRecord',
    method: 'get',
    params: params
  })
}
// 退货记录列表
export function refundRecordList(params) {
  return request({
    url: '/afterSales/record',
    method: 'get',
    params: params
  })
}
// 获取退货单详情
export function getRefundDetail(params) {
  return request({
    url: '/afterSales/detail',
    method: 'get',
    params: params
  })
}
// 退款
export function refundAmount(params) {
  return request({
    url: '/afterSales/mcht/refund',
    method: 'get',
    params: params
  })
}

// 驳回退款申请
export function rejectMoney(params) {
  return request({
    url: '/afterSales/mcht/rejectMoney',
    method: 'get',
    params: params
  })
}

// 商家同意退款申请
export function orderMchtRefund(params) {
  return request({
    url: '/afterSales/mcht/orderMchtRefund',
    method: 'get',
    params: params
  })
}
// 同意拒绝退货
export function handleRefund(params) {
  return request({
    url: '/afterSales/mcht/operation',
    method: 'put',
    data: params
  })
}

// 同意拒绝退货
export function updateStatus(params) {
  return request({
    url: '/afterSales/updateStatus',
    method: 'put',
    data: params
  })
}

// 同意拒绝退货
export function refundDelivery(params) {
  return request({
    url: '/afterSales/update/delivery',
    method: 'POST',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/afterSales.js